import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_PRODUCT_INFO = 'FETCH_PRODUCT_INFO';
export const fetchProductInfoActionTypes = createAsyncActionTypes(FETCH_PRODUCT_INFO);